import $foreign from "./foreign.cjs";
var nextMicrotask = $foreign.nextMicrotask;
export { nextMicrotask };
